"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("./Icon");
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var FavoriteWrapper = _styledComponents.default.div.withConfig({
  displayName: "Favorite__FavoriteWrapper",
  componentId: "sc-gqg5bj-0"
})(["display:inline-flex;align-items:center;justify-content:center;cursor:pointer;border-radius:", ";padding:", ";:hover{background:", ";}"], _styles.borderRadius.s, _styles.spacing.xxs, _styles.colors.background.tertiary.default);
var Favorite = function Favorite(_ref) {
  var favorite = _ref.favorite,
    size = _ref.size,
    _onClick = _ref.onClick,
    title = _ref.title;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FavoriteWrapper, {
    title: title,
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick();
    },
    children: favorite ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      size: size,
      icon: 'starFill',
      color: 'favorite'
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      size: size,
      icon: 'star'
    })
  });
};
Favorite.defaultProps = {
  favorite: false,
  onClick: function onClick() {
    return void 0;
  }
};
var _default = exports.default = Favorite;